enum VALUE_TYPE {
    PRICE = 'price',
    PERCENT = 'percent',
    NUMBER = 'number'
}

export default VALUE_TYPE;
